import i18next from "i18next";
import {
  loginConstants,
  userConstants,
  spotConstants,
  globalSystemConstants,
  translationConstants,
} from "../../constants";
import { UserActions } from "./user.actions";
import { centersActions } from "./centers.action";
import { ToastifyService, spotService } from "../../services";
import { success, custom } from "./utilities";
import { getUserPayload } from "../../system";

const {
  PUBLIC_SPOTS,
  SPOT_DATA_BY_ID,
  ADMIN_SPOTS_LIST,
  ALL_SPOTS,
  SPOT_DATA_BY_CENTER_ID,
  ALL_APPROVED_PUBLIC_PRIVATE_SPOTS,
  SPOT_DATA_BY_ID_NULL,
} = spotConstants;

//Get all paginated public and private spots list for admin spot listing
const getPaginatedSpots = (params) => {
  return (dispatch) => {
    dispatch(custom(ADMIN_SPOTS_LIST, globalSystemConstants.SPINNER_ACTIVATE));

    spotService
      .getPaginatedSpots(params)
      .then((response) => {
        dispatch(success(response, ADMIN_SPOTS_LIST));
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(ADMIN_SPOTS_LIST, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

//Get public/private spots by id
const getSpotById = (id) => {
  return (dispatch) => {
    dispatch(custom(SPOT_DATA_BY_ID, globalSystemConstants.SPINNER_ACTIVATE));

    spotService
      .getSpotById(id)
      .then((response) => {
        dispatch(success(response, SPOT_DATA_BY_ID));
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(SPOT_DATA_BY_ID, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

//Update public spots by id
const updatePublicSpot = (data, gridState, setShow) => {
  return (dispatch) => {
    dispatch(
      custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_ACTIVATE)
    );

    spotService
      .updatePublicSpot(data)
      .then((response) => {
        ToastifyService.showSuccess(i18next.t(response));
        dispatch(UserActions.OpenModal(false));
        dispatch(getPaginatedSpots(gridState));
        setShow(false);
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_DEACTIVATE)
        );
        dispatch(success(false, userConstants.OPEN_MODAL));
      });
  };
};

//Get all public spots list
const GetAllPublicSpots = (params) => {
  return (dispatch) => {
    spotService
      .getAllPublicSpots(params)
      .then((response) => {
        dispatch(success(response.data, PUBLIC_SPOTS));
      })
      .catch((error) => {
        ToastifyService.showError(error);
      });
  };
};

//Add public spot
const addPublicSpot = (data, gridState, setShow) => {
  return (dispatch) => {
    dispatch(
      custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_ACTIVATE)
    );

    spotService
      .addPublicSpot(data)
      .then((response) => {
        ToastifyService.showSuccess(
          i18next.t(translationConstants.DONE_SUCCESSFULLY)
        );
        dispatch(UserActions.OpenModal(false));
        setShow(false);
        dispatch(getPaginatedSpots(gridState));
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_DEACTIVATE)
        );
        dispatch(success(false, userConstants.OPEN_MODAL));
      });
  };
};

//Delete center public spot
const deletePublicSpot = (spotId, centerId) => {
  return (dispatch) => {
    dispatch(custom(SPOT_DATA_BY_ID, globalSystemConstants.SPINNER_ACTIVATE));

    spotService
      .deletePublicSpot(spotId)
      .then((response) => {
        ToastifyService.showSuccess(i18next.t(response));
        dispatch(centersActions.getCenterById(centerId));
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(SPOT_DATA_BY_ID, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

//Delete center private spot
const deletePrivateSpot = (spotId, centerId) => {
  return (dispatch) => {
    dispatch(custom(SPOT_DATA_BY_ID, globalSystemConstants.SPINNER_ACTIVATE));

    spotService
      .deletePrivateSpot(spotId)
      .then((response) => {
        ToastifyService.showSuccess(i18next.t(response));
        dispatch(centersActions.getCenterById(centerId));
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(SPOT_DATA_BY_ID, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

//Get all public and private spots
const getAllSpots = (param) => {
  return (dispatch) => {
    param?.length <= 10 &&
      dispatch(custom(ALL_SPOTS, globalSystemConstants.SPINNER_ACTIVATE));
    spotService
      .getAllSpots(param)
      .then((response) => {
        dispatch(success(response, ALL_SPOTS));
      })
      .catch((error) => {
        ToastifyService.showError(error);
      }).finally(() => {
        dispatch(
          custom(
            ALL_SPOTS,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};
//Get all Approved public and private spots
const getAllApprovedSpots = () => {
  return (dispatch) => {
    dispatch(
      custom(
        ALL_APPROVED_PUBLIC_PRIVATE_SPOTS,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );

    spotService
      .getAllApprovedSpots()
      .then((response) => {
        dispatch(success(response, ALL_APPROVED_PUBLIC_PRIVATE_SPOTS));
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(
            ALL_APPROVED_PUBLIC_PRIVATE_SPOTS,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};
const getSpotByCenterId = (id) => {
  return (dispatch) => {
    dispatch(custom(SPOT_DATA_BY_ID, globalSystemConstants.SPINNER_ACTIVATE));
    const userData = getUserPayload();
    spotService
      .getSpotByCenterId(userData.user.centerId)
      .then((response) => {
        dispatch(success(response, SPOT_DATA_BY_CENTER_ID));
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(SPOT_DATA_BY_ID, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

//Update public spots by id
const updatePublicSpotStatus = (data, gridState, setIsDisableShow) => {
  return (dispatch) => {
    dispatch(
      custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_ACTIVATE)
    );

    spotService
      .updatePublicSpotStatus(data)
      .then((response) => {
        ToastifyService.showSuccess(response);
        dispatch(getPaginatedSpots(gridState));
        setIsDisableShow(false);
      })
      .catch((error) => {
        ToastifyService.showError(error);
        setIsDisableShow(false);
      })
      .finally(() => {
        dispatch(
          custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

const setPrivateSpotReducerNull = () => {
  return (dispatch) => {
    dispatch(success(true, SPOT_DATA_BY_ID_NULL));
  };
};

export const SpotActions = {
  getPaginatedSpots,
  getSpotById,
  updatePublicSpot,
  GetAllPublicSpots,
  addPublicSpot,
  deletePublicSpot,
  deletePrivateSpot,
  getAllSpots,
  getSpotByCenterId,
  getAllApprovedSpots,
  updatePublicSpotStatus,
  setPrivateSpotReducerNull,
};
